import { useEffect, useState } from 'react'

import BigNumber from 'bignumber.js'
import { Contract } from 'web3-eth-contract'

const useBalanceOf = (tokenContract: Contract, address: string) => {
  const [balance, setBalance] = useState<BigNumber>()
  useEffect(() => {
    ;(async function getBalance() {
      try {
        const tokenAmount = await tokenContract.methods.balanceOf(address).call()
        setBalance(new BigNumber(tokenAmount))
      } catch (e) {
        console.error(e)
      }
    })()
  }, [tokenContract, address])
  return balance
}

export default useBalanceOf
